(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('candidateProfileTab', woProfileTab);

    var templateUrl = 'rms/templates/candidates/profile-tab';

    function woProfileTab(lodash, customDropdownButtonService) {
        return {
            restrict: 'E',
            controller: function($scope, $compile, $templateCache, $element) {
                var vm = $scope.vm;
                this.$onInit = function() {
                    var template = $templateCache.get(templateUrl);
                    if (lodash.has(vm.panelState, 'structure.options.template')) {
                        template = vm.panelState.structure.options.template;
                    }

                    $element.html(template);
                    const elementClone = $compile($element.contents())($scope);
                    $scope.$on('$destroy', () => {
                        elementClone.off();
                    });
                }
            },
            link: function(scope) {
                var vm = scope.vm;
                var profile_datasource = vm.panelState.structure.options.profile_datasource;


                scope.component_data = {
                    setView: setView,
                    selectDocument: selectDocument,
                    selectProfile: selectProfile,
                    selectItem: selectItem,
                    current_view: getCurrentView(),
                    isActive: isActive,
                    profile_datasource: profile_datasource,
                    printProfile: printProfile,
                };

                init();

                function init() {
                    switch (scope.component_data.current_view) {
                        case "resume":
                            selectDocument('resume', getFirstAttachment('resumes'));
                            break;
                        case "recruiter":
                        case "client":
                            setView(scope.component_data.current_view);
                            break;
                        case "attachment":
                            selectDocument('attachment', getFirstAttachment('attachments'));
                            break;
                    }
                }

                function getCurrentView() {
                    if (lodash.has(scope.vm.panelState.structure, 'options.default_view')) {
                        return scope.vm.panelState.structure.options.default_view;
                    }
                    if (lodash.has(scope.vm.panelState.structure, 'options.resumes')) {
                        return 'resume';
                    }
                    return 'profile';
                }

                function selectDocument(type, document) {
                    scope.component_data.active_document = document;

                    setView(type);
                }

                function selectProfile(item) {
                    customDropdownButtonService.closeAll();
                    scope.component_data.active_document = null;
                    if (lodash.has(item, 'document')) {
                        scope.component_data.active_document = item.document;
                    }
                    setView(item.value);
                }

                function selectItem(item) {
                    if (['attachment', 'resume'].indexOf(scope.component_data.current_view) >= 0) {
                        selectDocument(scope.component_data.current_view, item);
                    } else {
                        selectProfile(item);
                    }
                }

                function setView(view) {
                    if (!(['attachment', 'resume'].indexOf(view) >= 0)) {
                        var selected_profile = lodash.find(profile_datasource, { value: view});
                        scope.component_data.visibility = lodash.get(scope.vm.panelState.structure, 'options.visibility.' + view, {});
                        scope.component_data.selected_datasource = angular.copy(profile_datasource);
                        scope.component_data.current_selected_text = '<span>' + selected_profile.name + ' <i class="fa fa-caret-down"></i></span>';
                    } else {
                        if (view === 'attachment') {
                            scope.component_data.selected_datasource =  angular.copy(getAttachmentDs('attachments'));
                        }
                        if (view === 'resume') {
                            scope.component_data.selected_datasource = angular.copy(getAttachmentDs('resumes'));
                        }
                        scope.component_data.current_selected_text = '<span>' + scope.component_data.active_document.name + ' <i class="fa fa-caret-down"></i></span>';
                    }
                    if (scope.component_data.active_document !== null) {
                        if (typeof scope.component_data.refreshDocViewer == typeof function() {}) {
                            scope.component_data.refreshDocViewer();
                        }
                    }
                    scope.component_data.current_view = view;
                }

                function isActive(type) {
                    if (type === 'profile') {
                        return lodash.find(profile_datasource, { value: scope.component_data.current_view});
                    }
                    return type == scope.component_data.current_view;
                }

                function getAttachmentDs(type) {
                    var key = lodash.get(vm ,'panelState.structure.options.config.attachment_datasource_key', 'structure.options');
                    return lodash.get(vm.panelState, [key, type].join('.'), []);
                }

                function getFirstAttachment(type) {
                    var ds= getAttachmentDs(type);
                    return ds.length > 0 ? ds[0] : null;
                }

                function printProfile() {
                    // var ifr = document.createElement('iframe');
                    // ifr.style='height: 0px; width: 0px; position: absolute';
                    // ifr.onload = function() {
                    //
                    // };
                    // document.body.appendChild(ifr);
                    // $("<link/>",
                    //     { rel: "stylesheet", href: 'http://cdn.coolbeans.test/assets/css/rms.css', type: "text/css" }
                    // ).appendTo(ifr.contentDocument.head);
                    //
                    //
                    // $('.candidate-profile').clone().appendTo(ifr.contentDocument.body);
                    // ifr.contentDocument.body.className = 'rms-common';
                    // ifr.contentWindow.print();

                    // ifr.parentElement.removeChild(ifr);
                    var printElement =  document.createElement('div');
                    $(printElement).addClass('printSection');
                    document.body.append(printElement);
                    $('.candidate-profile').clone().appendTo(printElement);
                    var originalTitle = document.title;
                    var candidateName = $('.candidate-profile-detail-panel-header > span').text().trim();
                    if (candidateName.length === 0) {
                        $('div[ng-bind="profile_data.profile_overview.full_name"]').each(function () {
                            candidateName = $(this).text();
                        });
                    }
                    document.title = (candidateName || 'Candidate Profile').match(/\w+/g).join(' ');
                    if (typeof Tawk_API !== typeof undefined) {
                        Tawk_API.toggleVisibility();
                    }
                    window.print();
                    if (typeof Tawk_API !== typeof undefined) {
                        Tawk_API.toggleVisibility();
                    }
                    document.title = originalTitle;
                    $('.printSection').remove();
                }
            }
        };
    }
})();